import { getCalendarAgendaViewStore } from '../store/calendarAgendaViewStore';
import { mutator } from 'satcheljs';
import updateSelectedCalendarEvent from '../actions/updateSelectedCalendarEvent';

/**
 * Mutator that updates the selected calendar event
 */
mutator(updateSelectedCalendarEvent, actionMessage => {
    const { event } = actionMessage;
    getCalendarAgendaViewStore().selectedCalendarEventId = event.ItemId.Id;
});
